import React from "react"
export default function SubDrop ({item,setTabla,setShow}){
    const navButtonHandler = (op) => e =>{
        e.preventDefault()
        if(op){
            setTabla(op)
            setShow(true)
        }
    }
    return(
        <ul className="dropdown-menu dropdown-submenu sombras bg-light text-uppercase">
            {item.map(({title,icon,itemClickValue,subDrop,permission},key)=>(
                permission !== false &&(
                    <li className="text-uppercase" key={title+key}>
                        <button onClick={navButtonHandler(itemClickValue)} 
                        className="text-uppercase fw-bold dropdown-item bg-light py-2"
                        data-bs-dismiss={itemClickValue ? "offcanvas" : ''}>
                            <i className={icon} /> 
                            {title}
                        </button>
                        {subDrop && <SubDrop setTabla={setTabla} setShow={setShow} item={subDrop}/>}
                    </li>
                )
            ))}
        </ul>
    )
}
